import React from "react";
import { Tooltip, Button, message } from "antd";
import { PhoneOutlined } from "@ant-design/icons";

const PropertyCallingButton = () => {
  const handleCallClick = (e) => {
    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (!isMobile) {
      e.preventDefault(); // Prevent the default anchor behavior
      message.warning("Calling is only supported on mobile devices.");
    }
    // If it's mobile, the default href="tel:" will work
  };

  return (
    <Tooltip title="Call" placement="top">
      <a href="tel:+045771575" onClick={handleCallClick}>
        <Button
          type="default"
          icon={<PhoneOutlined />}
          size="middle"
          style={{
            borderColor: "#FDA94F",
            color: "#FDA94F",
            backgroundColor: "#fff",
            fontWeight: 500,
          }}
        >
          Call
        </Button>
      </a>
    </Tooltip>
  );
};

export default PropertyCallingButton;
